import { RoadmapItem } from "@/models/RoadmapItem"
import { getAuthedApi } from "../api/api"

export const getRoadmapData = async () => {
    const api = await getAuthedApi()
    const response = await api.post<JiraGatewayResponse<RoadmapItem>>(`api/v2.0/roadmap/search`, {})
    return response.data.items
}

interface JiraGatewayResponse<T> {
    items: T[],
    totalCount: number,
    pageSize: number,
    currentPage: number
    pageCount: number
}
